import { Input } from '@/components/ui/input';
import { FC, useEffect, useState } from 'react';
import { useDebounce } from 'components/Debounce';
import { Loader } from 'components/Loader';

export const Search: FC<{
  value: string;
  onChange: (e: string) => void;
  placeholder?: string;
  isLoading: boolean;
}> = ({ value, onChange, placeholder, isLoading }) => {
  const [search, setSearch] = useState(value);
  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    onChange(debouncedSearch);
  }, [debouncedSearch, onChange]);

  return (
    <div className="flex flex-row">
      <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={placeholder} />
      {isLoading && <Loader />}
    </div>
  );
};
